export const KIOSK_CONFIG_NAME_KEY = "kiosk_config_name"
